// extracted by mini-css-extract-plugin
module.exports = {"content":"registration_content__wp-Bm","actions":"registration_actions__3JdsH"};